import Api from '@/services/Api';
import Unidade from '@/model/Unidade';

const RECURSO = '/unidades';
export default {
    newUnidade,
    getUnidade,
    getAllUnidade,
    getUnidadePrivilegios,
    postUnidade,
    postUnidadeRetornar,
    putUnidade,
    deleteUnidade,
};

function newUnidade(id=0, nome='', sigla=''){
    return new Unidade(id,nome,sigla);
}

function getUnidade (id) {
    return Api.get(`${RECURSO}/${id}`);
}

function getAllUnidade(){
    return Api.get(`${RECURSO}`)
}

function getUnidadePrivilegios (id) {
    return Api.get(`${RECURSO}/${id}/privilegios`);
}

function postUnidade(payload){
    return Api.post(`${RECURSO}`, payload);
}

function postUnidadeRetornar(payload){
    return Api.post(`${RECURSO}/retornar`, payload);
}

function putUnidade(payload){
    return Api.put(`${RECURSO}/${payload.id}`, payload);
}

function deleteUnidade(id){
    return Api.delete(`${RECURSO}/${id}`);
}
